import { VideoPlayerContext } from '@rhg/providers/video-player';
import { useContext } from 'react';

export function useVideoPlayer() {
    return useContext(VideoPlayerContext);
}
